export default __webpack_public_path__ + "045424e586ef6a8444d6222b501e1333.ogg";